$(document).ready(function () {
    $('.slick-gallery').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,            // Hides navigation arrows on mobile
      dots: true,               // Pagination dots
      infinite: true,           // Loop through slides
      autoplay: true,           // Auto slide
      autoplaySpeed: 2000,      // Time between slides
      speed: 1000,              // Transition speed
      swipeToSlide: true,       // allows multi-image slide
      swipe: true,              // Enable swipe for mobile
      touchMove: true,          // Allow touch interactions
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
          }
        },
          {
            breakpoint: 1024,
            settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            }
          }
        
      ]
    
      
    });
  });
  
